import { i18n } from "@/utils/i18n";
import { TableCell, TableHead, TableRow, Typography } from "@mui/material";
import React from "react";

const Header: React.FC = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell>
                    <Typography variant="subtitle1" fontWeight="bold">
                        Ref.nr
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle1" fontWeight="bold">
                        {i18n.t("date")}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle1" fontWeight="bold">
                        {i18n.t("importSource")}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle1" fontWeight="bold">
                        {i18n.t("description")}
                    </Typography>
                </TableCell>
                <TableCell align="right">
                    <Typography variant="subtitle1" fontWeight="bold">
                        {i18n.t("amount")}
                    </Typography>
                </TableCell>
                <TableCell align="right">
                    <Typography variant="subtitle1" fontWeight="bold">
                        {i18n.t("balance")}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography variant="subtitle1" fontWeight="bold">
                        {i18n.t("download")}
                    </Typography>
                </TableCell>
            </TableRow>
        </TableHead>
    );
};

export default Header;
